import React, {useCallback} from 'react'
import DatePicker from '~/code/components/dumb/DatePicker/DatePicker'
import {Moment} from 'moment'

import {RangePickerProps} from '@/components/dumb/RangePicker/props'
import { MONTH_FORMAT } from '@/constants'
import {isOctoberRestrictionEnabled} from '@/constants/dateRangePresets'
import {disabledDatesBeforeOctober2025} from '@/utils/moment-utils'
import styles from './styles.scss'

const {RangePicker} = DatePicker

export const MonthPicker: React.FC<RangePickerProps> = (props) => {
    const _disabledDate = useCallback(
        (date: Moment) => {
            if (isOctoberRestrictionEnabled && disabledDatesBeforeOctober2025(date)) {
                return true
            }
            return false
        },
        []
    )

    return (
        <>
            <div className={styles.monthPickerWrapper}>
                <RangePicker
                    allowClear={false}
                    picker="month"
                    format={MONTH_FORMAT}
                    value={[props.startDate, props.endDate]}
                    onChange={props.onMonthsChange}
                    disabledDate={isOctoberRestrictionEnabled ? _disabledDate : null}
                />
            </div>
        </>
    )
}
